<template>
  <div
    class="alert-banner-container"
    :class="{
      warning: property.alert_display_type == 'warning',
      danger: property.alert_display_type == 'danger',
    }"
  >
    <div class="container">
      <div
        class="page-body"
        v-html="property.alert_message"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const props = defineProps(["property"]);
</script>

<style scoped lang="scss">
:global(.fade-slide-enter-active),
:global(.fade-slide-leave-active) {
  transition: all 0.5s ease;
}

:global(.fade-slide-enter-from),
:global(.fade-slide-leave-to) {
  opacity: 0;
  transform: translateY(-20px);
}

.alert-banner-container {
  transition: all 0.3s ease;
  background-color: $white;
  font-family: $font_poppin;
  font-size: 14px;
  color: $black;
  padding: 10px;
  
  &.warning {
    background-color: #727272;
    color: $black;
  }

  &.danger {
    background-color: black;
    color: $white;
    border-bottom: 1px solid $white;
  }

  
  .page-body {
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    text-align: center;

    :deep(p) {
      margin-bottom: 0;
    }
  }
}
</style>